module.exports = __webpack_public_path__ + "static/media/mastercard.f59cd344.svg";